import Vue from 'vue';
import Vuex from 'vuex';
import VueContentPlaceholders from 'vue-content-placeholders';

/**
 * Vue is a modern JavaScript library for building interactive web interfaces
 * using reactive data binding and reusable components. Vue's API is clean
 * and simple, leaving you to focus on building your next great project.
 *
 * We use require instead of import to ensure the correct loading order.
 */

window.Vue = Vue;

Vue.config.productionTip = false;

// Register general extensions
Vue.use(Vuex);
Vue.use(VueContentPlaceholders);

// Install our view-stack
Vue.use(require('./view-stack').default);

// Register stack extensions
Vue.use(require('./admin/conversation').default);

// Add support for bootstrap goodies
Vue.use(require('./modal').default);
Vue.directive('dropdown', require('./directives/dropdown').default);
Vue.directive('tooltip', require('./directives/tooltip').default);

// Our custom notification system (no unnecessary features)
Vue.use(require('./notifications').default);

// Register custom extensions
Vue.use(require('./vue-extensions/utils').default);
Vue.use(require('./vue-extensions/color').default);
Vue.use(require('./vue-extensions/date').default);
Vue.use(require('./vue-extensions/presenters').default);

// Register custom components
Vue.component('activity-stream', () => import('./components/activity/stream.vue'));
Vue.component('avatar', () => import('./components/avatar.vue'));
Vue.component('calendar', () => import('./calendar/app.vue'));
Vue.component('datepicker', () => import('./components/datepicker.vue'));
Vue.component('markdown-editor', () => import('./components/markdown-editor.vue'));
Vue.component('messages', () => import('./components/messages.vue'));
Vue.component('typeahead', () => import('./components/typeahead.vue'));

Vue.component('grades-chart', require('./components/grades-chart.vue'));
Vue.component('tab', require('./components/tab.vue'));
Vue.component('tabs', require('./components/tabs.vue'));
Vue.component('v-table', require('./components/table.vue'));

// Register pages
Vue.component('page-user-grades', require('./pages/user/grades.vue'));

// Helper function for easy embedding into the site
window.insertVueComponent = function insertVueComponent(component, props, el = '#app') {
  return new Vue({
    el, render: h => h('div', { class: 'stack-wrapper' }, [h(component, { props })]),
  });
};



// WEBPACK FOOTER //
// ./resources/assets/js/vue.js